import React from 'react';
import styled from '@emotion/styled';

import { calcVw } from '~/styles/helpers';

const Gradient = styled.div`
    display: none;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        right: 50%;
        bottom: 0;
        margin: 0 ${calcVw(-50)};
        background-image: ${({ theme }) =>
            `linear-gradient(24deg, ${theme.colors.text.black} 12%, rgba(${theme.colors.text.blackRgb}, 0.5) 24%,  rgba(${theme.colors.text.blackRgb}, 0) 38%)`};
        z-index: ${({ theme }) => theme.zIndex.textGradient};
    }
    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        display: block;
    }
`;

const TextGradient = () => <Gradient />;

export default TextGradient;
